<template>
  <div class="product-operate">
    <span class="products-label">生成样式：</span>
    <ul class="products">
      <li
        :class="{ on: product.isShow }"
        v-for="product of products"
        :key="product.enName"
        @click="$emit('addToPreview', product)"
      >
        <span :class="`icon ${product.enName}-icon`"></span>
        <span class="name">{{ product.name }}</span>
        <span class="check" v-if="product.isShow"></span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "AiProducts",
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.product-operate {
  .products-label {
    display: block;
    margin-top: 32px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.6);
  }
  .products {
    margin-top: 8px;
    display: flex;
    gap: 16px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      position: relative;
      cursor: pointer;
      width: calc(50% - 8px);
      height: 125px;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      border-radius: 8px;
      // border: 1px solid rgba(148, 131, 255, 0.3);
      background: rgba(148, 131, 255, 0.3);
      .icon {
        position: relative;
        z-index: 3;
        display: block;
        border-radius: 4px;
        border: 1px solid rgba(138, 181, 255, 0.4);
        background: #454e5a;
      }
      .cover-icon {
        width: 73px;
        height: 45px;
      }
      .banner-icon {
        width: 102px;
        height: 45px;
      }
      .poster-icon {
        width: 44px;
        height: 69px;
      }
      .name {
        position: relative;
        z-index: 3;
        margin-top: 8px;
        display: block;
        color: #fff;
        font-size: 14px;
        line-height: 18px;
      }
      &:before,
      &:after {
        content: "";
        position: absolute;
        top: 1px;
        left: 1px;
        right: 1px;
        bottom: 1px;
        border-radius: 8px;
        background: #242931;
        cursor: pointer;
      }
      &:after {
        z-index: 0;
        background: rgba(33, 37, 49, 0.9);
      }
      &.on,
      &:hover {
        background: linear-gradient(90deg, #8569d9, #43bbff, #8093f7);
        &:before {
          z-index: 1;
          background: linear-gradient(295deg, rgba(122, 85, 232, 0.2) -2.91%, rgba(23, 143, 255, 0.2) 89.83%);
        }
      }
      // &:hover {
      //   &:before {
      //     top: 0;
      //     left: 0;
      //     right: 0;
      //     bottom: 0;
      //   }
      // }
      .check {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 35px;
        height: 22px;
        background: url(./../icon/ai-check.png) no-repeat center center;
        background-size: 100% 100%;
        z-index: 3;
      }
    }
  }
}
</style>
